/**
 * Anything PostUser is willing to render. Flarum types its `post` attr loosely
 * because private-message extensions pass their own model through the same
 * component, so nothing here may assume a real Post.
 */

/**
 * The handle a post or discussion carries, or null if it carries none.
 *
 * NULL MEANS "THIS IS NOT ONE OF OURS", NOT "THIS PERSON HAS NO HANDLE". The
 * API always sends a string for a post or a discussion -- an unresolved
 * contributor gets `DisplayIdentity::UNRESOLVED_NAME`, never an empty value --
 * so the only way to arrive here with nothing is a model that is not a post or
 * a discussion at all. Callers leave Flarum's own rendering alone in that case
 * rather than blanking a name they do not understand.
 *
 * Read defensively for the same reason: `handle` is our attribute, and another
 * extension's model reaching PostUser will not have it.
 */
export function handleOf(model) {
  const candidate = model;
  if (!candidate || typeof candidate.handle !== 'function') {
    return null;
  }
  const handle = candidate.handle();
  return typeof handle === 'string' && handle.length > 0 ? handle : null;
}